<template>

    <div class="dashboard">
        <HeaderUI/>
        <main class="page-main">
            <div class="page-container">

                <div class="page-header">
                    <div>
                        <h1 class="page-title">Дашборд</h1>
                        <p class="page-description">Статистика генерации актов по всем сотрудникам</p>
                    </div>
                    <ButtonUI :title="'Обновить'" :icon="'restore'" variant="outline" @click="loadAll()"/>
                </div>

                <div class="grid-2">
                    <section class="card">
                        <div class="card-body">
                            <div class="stat-label"><AppIcon name="doc" class="stat-icon"/> Актов сгенерировано</div>
                            <div class="stat-value">{{ stats ? stats.total_acts : '—' }}</div>
                        </div>
                    </section>
                    <section class="card">
                        <div class="card-body">
                            <div class="stat-label"><AppIcon name="package" class="stat-icon"/> Позиций в актах</div>
                            <div class="stat-value">{{ stats ? stats.total_items : '—' }}</div>
                        </div>
                    </section>
                    <section class="card">
                        <div class="card-body">
                            <div class="stat-label"><AppIcon name="users" class="stat-icon"/> Пользователей</div>
                            <div class="stat-value">{{ stats ? stats.users_count : '—' }}</div>
                        </div>
                    </section>
                    <section class="card">
                        <div class="card-body">
                            <div class="stat-label"><AppIcon name="clock" class="stat-icon"/> Последняя генерация</div>
                            <div class="stat-value stat-value--sm">{{ stats && stats.last_generated_at ? format_date(stats.last_generated_at) : '—' }}</div>
                        </div>
                    </section>
                </div>

                <div class="dash-grid">

                    <section class="card top-card">
                        <div class="card-header">
                            <div class="card-title">
                                <AppIcon name="trophy" class="card-title-icon"/>
                                Топ сотрудников по актам
                            </div>
                        </div>
                        <div class="card-body top-body">

                            <div v-if="stats_loading" class="empty">Загрузка...</div>

                            <div v-else-if="!stats || stats.by_user.length === 0" class="empty">
                                Пока нет ни одного сгенерированного акта
                            </div>

                            <div v-else class="top-list">
                                <div class="top-item" v-for="(item, index) in stats.by_user" :key="item.user_id">
                                    <span class="top-place" :class="'top-place--' + (index + 1)">{{ index + 1 }}</span>
                                    <span class="top-avatar">{{ user_login(item.user_id) ? user_login(item.user_id).charAt(0).toUpperCase() : '?' }}</span>
                                    <span class="top-name">{{ user_login(item.user_id) || ('ID ' + item.user_id) }}</span>
                                    <span class="top-count">
                                        {{ item.acts }}
                                        {{ item.acts == 1 ? 'акт' : (item.acts >= 2 && item.acts <= 4 ? 'акта' : 'актов') }}
                                    </span>
                                </div>
                            </div>

                        </div>
                    </section>


                    <section class="card activity-card">
                        <div class="card-header">
                            <div class="card-title">
                                <AppIcon name="chart" class="card-title-icon"/>
                                Активность
                                <span class="badge badge--soft" v-if="activity_total > 0">{{ activity_total }}</span>
                            </div>
                        </div>
                        <div class="card-body">

                            <div v-if="activity_loading" class="empty">Загрузка...</div>

                            <div v-else-if="activity.length === 0" class="empty">
                                Здесь появится лента всех сгенерированных актов
                            </div>

                            <template v-else>
                                <div class="act-list">
                                    <div class="act-item" v-for="record in activity" :key="record.id">
                                        <div class="act-icon-wrap"><AppIcon name="doc" class="act-icon"/></div>
                                        <div class="act-body">
                                            <div class="act-title">
                                                <span class="act-user">{{ user_login(record.user_id) || 'Сотрудник' }}</span>
                                                сгенерировал акт для
                                                <span class="act-target">{{ record.accept_user || '—' }}</span>
                                            </div>
                                            <div class="act-sub">
                                                {{ format_date(record.created_at) }} ·
                                                {{ record.items ? record.items.length : 0 }} поз. ·
                                                {{ record.tmc_type == '2' ? 'Телефония' : 'ТМЦ' }}
                                                <template v-if="record.is_kurch || record.tmc_type == '2'">
                                                    · «{{ record.kurch_text || 'Курчатов' }}»
                                                </template>
                                            </div>
                                        </div>
                                        <button type="button" class="row-btn" title="Скачать DOC" @click="downloadHistory(record)">
                                            <AppIcon name="download" class="row-btn-icon"/>
                                        </button>
                                        <button type="button" class="row-btn" title="Предпросмотр DOC" @click="previewHistory(record)">
                                            <AppIcon name="eye" class="row-btn-icon"/>
                                        </button>
                                    </div>
                                </div>

                                <div class="activity-footer">
                                    <PaginationUI :page="activity_page" :pages="activity_pages" @change="onActivityPage"/>
                                </div>
                            </template>

                        </div>
                    </section>

                </div>

            </div>
        </main>

        <ModalUI :open="preview_modal" @close="closePreview()" :title="'Предпросмотр акта'" :icon="'eye'" :width="860">
            <div v-if="preview_loading" class="empty">Загрузка...</div>

            <div v-else-if="!preview_url" class="empty">Не удалось загрузить файл предпросмотра</div>

            <iframe v-else class="preview-frame" :src="preview_url" title="Предпросмотр акта"></iframe>
        </ModalUI>
    </div>

</template>


<script>

import HeaderUI from '@/components/HeaderUI.vue'
import ButtonUI from '@/components/ButtonUI.vue'
import PaginationUI from '@/components/PaginationUI.vue'
import ModalUI from '@/components/ModalUI.vue'
import AppIcon from '@/components/AppIcon.vue'

import axios from 'axios'

const API_URL = '/api/v1'

export default {
    name: 'DashboardView',

    components: {
        HeaderUI,
        ButtonUI,
        PaginationUI,
        ModalUI,
        AppIcon
    },

    created() {
        this.loadAll();
    },

    data() {
        return {
            stats: null,
            stats_loading: false,
            users: [],
            activity: [],
            activity_loading: false,
            activity_page: 1,
            activity_pages: 1,
            activity_total: 0,

            preview_modal: false,
            preview_loading: false,
            preview_url: null
        }
    },

    methods: {
        loadAll() {
            this.loadStats();
            this.loadUsers();
            this.loadActivity();
        },

        loadStats() {
            this.stats_loading = true;

            axios.get(API_URL + '/history/stats').then((response) => {
                this.stats = response.data;
            }).catch((error) => {
                console.log(error);
            }).finally(() => {
                this.stats_loading = false;
            });
        },

        loadUsers() {
            axios.get(API_URL + '/users').then((response) => {
                this.users = response.data;
            }).catch((error) => {
                console.log(error);
            });
        },

        loadActivity() {
            this.activity_loading = true;

            axios.get(API_URL + '/history/paged', {
                params: {
                    page: this.activity_page,
                    page_size: 8
                }
            }).then((response) => {
                this.activity = response.data.items;
                this.activity_pages = response.data.pages;
                this.activity_total = response.data.total;
            }).catch((error) => {
                console.log(error);
            }).finally(() => {
                this.activity_loading = false;
            });
        },

        onActivityPage(page) {
            this.activity_page = page;
            this.loadActivity();
        },

        user_login(user_id) {
            const user = this.users.find((u) => String(u.user_id) === String(user_id));

            return user ? user.login : null;
        },

        format_date(timestamp) {
            if (!timestamp) {
                return '—';
            }

            const d = new Date(timestamp * 1000);

            const pad = (num) => String(num).padStart(2, '0');

            return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
        },

        downloadHistory(record) {
            window.location.href = API_URL + "/generator/download?file_name=" + record.file_name;
        },

        previewHistory(record) {
            if (this.preview_url) {
                URL.revokeObjectURL(this.preview_url);
                this.preview_url = null;
            }

            this.preview_modal = true;
            this.preview_loading = true;

            axios.get(API_URL + "/generator/preview", {
                params: {
                    file_name: record.file_name,
                    history_id: record.id
                },
                responseType: 'blob'
            }).then((response) => {
                this.preview_url = URL.createObjectURL(new Blob([response.data], { type: 'text/html' }));
            }).catch((error) => {
                console.log(error);
                this.preview_url = null;
                alert('Не удалось загрузить файл предпросмотра');
            }).finally(() => {
                this.preview_loading = false;
            });
        },

        closePreview() {
            this.preview_modal = false;

            if (this.preview_url) {
                URL.revokeObjectURL(this.preview_url);
                this.preview_url = null;
            }
        }
    }
}

</script>


<style scoped>

.dashboard{
    width: 100%;
    min-height: 100vh;

    display: flex;
    flex-direction: column;
}

.stat-label{
    display: flex;
    align-items: center;
    gap: 6px;

    font-size: 13px;
    color: var(--muted-foreground);
}

.stat-icon{
    width: 14px;
    height: 14px;
}

.stat-value{
    margin-top: 6px;

    font-size: 28px;
    font-weight: 600;
    letter-spacing: -0.02em;
}

.stat-value--sm{
    font-size: 18px;
}

/* --- Сетка: топ + активность --- */

.dash-grid{
    display: grid;
    grid-template-columns: 320px minmax(0, 1fr);
    gap: 20px;

    align-items: start;
}

.top-card{
    margin-bottom: 0;
}

.activity-card{
    margin-bottom: 0;
}

/* --- Топ сотрудников --- */

.top-list{
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.top-item{
    display: flex;
    align-items: center;
    gap: 10px;

    padding: 8px 10px;

    background: var(--muted);
    border-radius: 8px;
}

.top-place{
    display: inline-flex;
    align-items: center;
    justify-content: center;

    width: 24px;
    height: 24px;

    background: var(--card);
    border: 1px solid var(--border);
    border-radius: 999px;

    font-size: 12px;
    font-weight: 600;
    color: var(--muted-foreground);

    flex-shrink: 0;
}

.top-place--1{
    background: var(--primary);
    border-color: var(--primary);
    color: var(--primary-foreground);
}

.top-avatar{
    display: inline-flex;
    align-items: center;
    justify-content: center;

    width: 28px;
    height: 28px;

    background: var(--card);
    border: 1px solid var(--border);
    border-radius: 999px;

    font-size: 12px;
    font-weight: 600;

    flex-shrink: 0;
}

.top-name{
    flex: 1;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    font-size: 14px;
    font-weight: 500;
}

.top-count{
    font-size: 13px;
    color: var(--muted-foreground);

    flex-shrink: 0;
}

/* --- Лента активности --- */

.act-list{
    display: flex;
    flex-direction: column;
}

.act-item{
    display: flex;
    align-items: center;
    gap: 12px;

    padding: 12px 4px;

    border-bottom: 1px solid var(--border);
}

.act-item:last-child{
    border-bottom: none;
}

.act-icon-wrap{
    display: inline-flex;
    align-items: center;
    justify-content: center;

    width: 36px;
    height: 36px;

    background: var(--muted);
    border-radius: 10px;

    flex-shrink: 0;
}

.act-icon{
    width: 16px;
    height: 16px;

    color: var(--muted-foreground);
}

.act-body{
    flex: 1;

    min-width: 0;
}

.act-title{
    font-size: 14px;
}

.act-user{
    font-weight: 600;
}

.act-target{
    font-weight: 500;
}

.act-sub{
    margin-top: 2px;

    font-size: 12px;
    color: var(--muted-foreground);
}

.activity-footer{
    display: flex;
    justify-content: flex-end;

    margin-top: 14px;
}

.row-btn{
    display: inline-flex;
    align-items: center;
    justify-content: center;

    width: 28px;
    height: 28px;

    background: transparent;
    border: none;
    border-radius: 6px;
    color: var(--muted-foreground);

    cursor: pointer;

    transition: background-color 0.15s ease, color 0.15s ease;
}

.row-btn:hover{
    background: var(--muted);
    color: var(--foreground);
}

.row-btn-icon{
    width: 15px;
    height: 15px;
}

.badge{
    display: inline-flex;
    align-items: center;

    padding: 2px 8px;

    background: var(--muted);
    border: 1px solid var(--border);
    border-radius: 999px;

    font-size: 12px;
    color: var(--muted-foreground);
}

.badge--soft{
    padding: 1px 8px;
}

/* --- Предпросмотр DOC --- */

.preview-frame{
    width: 100%;
    height: 70vh;

    border: 1px solid var(--border);
    border-radius: 8px;

    background: var(--card);
}

/* Подписи и надпись внутри HTML-предпросмотра */
.preview-frame :deep(.sign-table) td{
    border: none;
}

.preview-frame :deep(.sign-note){
    text-align: right;
    font-style: italic;
    font-size: 12px;
}

/* --- Адаптив --- */

@media (max-width: 960px){
    .dash-grid{
        grid-template-columns: 1fr;
    }
}

</style>
